module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "message"
  }, [_c('van-collapse', {
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, [(_vm.accountFlag == '1') ? _c('van-collapse-item', {
    staticClass: "backCollapseItem",
    attrs: {
      "name": "1"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('div', {
          staticClass: "activeTitles"
        }, [_vm._v("账号信息")])]
      },
      proxy: true
    }], null, false, 538426519)
  }, [_vm._v(" "), _c('ul', {
    staticClass: "messageUl"
  }, [_c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("收款人姓名")]), _vm._v(" "), _c('p', {
    staticClass: "liR",
    class: {
      'noGrey': _vm.payeeName != '请填写收款人姓名'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payeeName),
      expression: "payeeName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写收款人姓名"
    },
    domProps: {
      "value": (_vm.payeeName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payeeName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("收款人身份证号")]), _vm._v(" "), _c('p', {
    staticClass: "liR",
    class: {
      'noGrey': _vm.payeeCertNo != '请填写收款人身份证号'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payeeCertNo),
      expression: "payeeCertNo"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写收款人身份证号"
    },
    domProps: {
      "value": (_vm.payeeCertNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payeeCertNo = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("收款人电话")]), _vm._v(" "), _c('p', {
    staticClass: "liR",
    class: {
      'noGrey': _vm.payeePhone != '请填写收款人电话'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payeePhone),
      expression: "payeePhone"
    }],
    attrs: {
      "type": "number",
      "placeholder": "请填写收款人电话"
    },
    domProps: {
      "value": (_vm.payeePhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payeePhone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("银行名称")]), _vm._v(" "), _c('p', {
    staticClass: "liR",
    class: {
      'noGrey': _vm.bankName != '请填写银行名称'
    }
  }, [_c('van-field', {
    attrs: {
      "rows": "1",
      "autosize": "",
      "type": "textarea",
      "placeholder": "请填写银行名称"
    },
    model: {
      value: (_vm.bankName),
      callback: function($$v) {
        _vm.bankName = $$v
      },
      expression: "bankName"
    }
  })], 1)]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("银行账号")]), _vm._v(" "), _c('p', {
    staticClass: "liR",
    class: {
      'noGrey': _vm.bankCode != '请填写银行账号'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankCode),
      expression: "bankCode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写银行账号"
    },
    domProps: {
      "value": (_vm.bankCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bankCode = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.bankListFlag) ? _c('div', {
    staticClass: "bankList"
  }, _vm._l((_vm.bankList), function(item, index) {
    return _c('span', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.selBankList(item)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.bankName) + "\n              ")])
  }), 0) : _vm._e()]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("银行所在省份")]), _vm._v(" "), _c('p', {
    staticClass: "liR",
    class: {
      'noGrey': _vm.bankProvinceName != '请填写银行所在省份'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankProvinceName),
      expression: "bankProvinceName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写银行所在省份"
    },
    domProps: {
      "value": (_vm.bankProvinceName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bankProvinceName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("银行所在地市")]), _vm._v(" "), _c('p', {
    staticClass: "liR",
    class: {
      'noGrey': _vm.bankCityName != '请填写银行所在地市'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankCityName),
      expression: "bankCityName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写银行所在地市"
    },
    domProps: {
      "value": (_vm.bankCityName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bankCityName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("开户支行")]), _vm._v(" "), _c('p', {
    staticClass: "liR",
    class: {
      'noGrey': _vm.bankSubName != '请填写开户支行'
    },
    staticStyle: {
      "position": "relative"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写开户支行"
    },
    on: {
      "focus": _vm.bankSubNameClick,
      "input": function($event) {
        return _vm.querySubBank(_vm.bankSubName)
      },
      "blur": _vm.bankSubNameBlur
    },
    model: {
      value: (_vm.bankSubName),
      callback: function($$v) {
        _vm.bankSubName = $$v
      },
      expression: "bankSubName"
    }
  }), _vm._v(" "), (_vm.subBankList.length > 0) ? _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bankSubSelectShow),
      expression: "bankSubSelectShow"
    }],
    staticClass: "bankSubNameSelectDwon",
    staticStyle: {
      "position": "absolute",
      "width": "100%"
    }
  }, _vm._l((_vm.subBankList), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "mousedown": function($event) {
          _vm.bankSubName = item
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0) : _vm._e()], 1)])])]) : _vm._e(), _vm._v(" "), _c('van-collapse-item', {
    attrs: {
      "title": "挂科信息",
      "name": "2"
    }
  }, [_c('ul', {
    staticClass: "messageUl"
  }, [_c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("挂科日期"), _c('i', {
    staticStyle: {
      "font-size": "12px",
      "font-style": "normal"
    }
  }, [_vm._v("(当次挂科日期)")])]), _vm._v(" "), _c('p', {
    staticClass: "liR sel",
    class: {
      'noGrey': _vm.selCurrentDate != '请选择挂科日期'
    },
    on: {
      "click": _vm.openDatetime
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.selCurrentDate))])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("挂科省")]), _vm._v(" "), _c('p', {
    staticClass: "liR sel",
    class: {
      'noGrey': _vm.position != '请选择挂科地区'
    },
    on: {
      "click": function($event) {
        return _vm.openCity(1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.position))])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("挂科市")]), _vm._v(" "), _c('p', {
    staticClass: "liR",
    class: {
      'noGrey': _vm.cxs != '请填写挂科市'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cxs),
      expression: "cxs"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写挂科市"
    },
    domProps: {
      "value": (_vm.cxs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cxs = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("挂科区/县")]), _vm._v(" "), _c('p', {
    staticClass: "liR",
    class: {
      'noGrey': _vm.cxx != '请填写挂科区/县'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cxx),
      expression: "cxx"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写挂科区/县"
    },
    domProps: {
      "value": (_vm.cxx)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cxx = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("挂科考场名称")]), _vm._v(" "), _c('p', {
    staticClass: "liR",
    class: {
      'noGrey': _vm.cxkcmc != '请填写挂科考场名称'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cxkcmc),
      expression: "cxkcmc"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写挂科考场名称"
    },
    domProps: {
      "value": (_vm.cxkcmc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cxkcmc = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("驾校所在地区")]), _vm._v(" "), _c('p', {
    staticClass: "liR",
    class: {
      'noGrey': _vm.jxPosition != '请选择驾校所在地'
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.jxPosition))])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("补偿科目")]), _vm._v(" "), _c('p', {
    staticClass: "liR sel",
    class: {
      'noGrey': _vm.claimClass != '请选择补偿科目'
    },
    on: {
      "click": _vm.openClaimClass
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.claimClass))])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("考试结果")]), _vm._v(" "), _c('p', {
    staticClass: "liR",
    class: {
      'noGrey': _vm.result != '请选择考试结果'
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.result))])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("考试成绩")]), _vm._v(" "), _c('p', {
    staticClass: "liR"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.score),
      expression: "score"
    }],
    class: {
      'noGrey': _vm.score != ''
    },
    attrs: {
      "type": "number",
      "placeholder": "请填写考试成绩"
    },
    domProps: {
      "value": (_vm.score)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.score = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("交管12123密码")]), _vm._v(" "), _c('p', {
    staticClass: "liR"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password122),
      expression: "password122"
    }],
    class: {
      'noGrey': _vm.password122 != ''
    },
    attrs: {
      "type": "text",
      "placeholder": "交管12123密码"
    },
    domProps: {
      "value": (_vm.password122)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password122 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("补偿金额")]), _vm._v(" "), _c('p', {
    staticClass: "liR"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.claimFee),
      expression: "claimFee"
    }],
    class: {
      'noGrey': _vm.claimFee != '0'
    },
    attrs: {
      "type": "text",
      "placeholder": "0"
    },
    domProps: {
      "value": (_vm.claimFee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.claimFee = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "liL"
  }, [_vm._v("是否自动截图")]), _vm._v(" "), _c('p', {
    staticClass: "liR"
  }, [_c('van-radio-group', {
    model: {
      value: (_vm.autoFee),
      callback: function($$v) {
        _vm.autoFee = $$v
      },
      expression: "autoFee"
    }
  }, [_c('van-radio', {
    staticStyle: {
      "margin": "5px 0px"
    },
    attrs: {
      "name": "1"
    }
  }, [_vm._v("自动截图")])], 1)], 1)])]), _vm._v(" "), (_vm.autoFee == '2') ? _c('ul', {
    staticClass: "h5Camera",
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_c('li', [_c('span', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("学员信息页")]), _vm._v(" "), _c('p', {
    staticClass: "liR"
  }, [_c('van-uploader', {
    attrs: {
      "preview-size": "100px",
      "after-read": function (file) {
        _vm.afterRead(file, 10)
      },
      "before-read": _vm.beforeRead,
      "max-count": 1
    },
    on: {
      "delete": function (file) {
        _vm.deletePhoto(file, 2)
      }
    },
    model: {
      value: (_vm.stuInfoUrl),
      callback: function($$v) {
        _vm.stuInfoUrl = $$v
      },
      expression: "stuInfoUrl"
    }
  })], 1)]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("考试成绩页")]), _vm._v(" "), _c('p', {
    staticClass: "liR"
  }, [_c('van-uploader', {
    attrs: {
      "preview-size": "100px",
      "after-read": function (file) {
        _vm.afterRead(file, 11)
      },
      "before-read": _vm.beforeRead,
      "max-count": 1
    },
    on: {
      "delete": function (file) {
        _vm.deletePhoto(file, 2)
      }
    },
    model: {
      value: (_vm.testScoreUrl),
      callback: function($$v) {
        _vm.testScoreUrl = $$v
      },
      expression: "testScoreUrl"
    }
  })], 1)]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("首次科目一预约页")]), _vm._v(" "), _c('p', {
    staticClass: "liR"
  }, [_c('van-uploader', {
    attrs: {
      "preview-size": "100px",
      "after-read": function (file) {
        _vm.afterRead(file, 12)
      },
      "before-read": _vm.beforeRead,
      "max-count": 1
    },
    on: {
      "delete": function (file) {
        _vm.deletePhoto(file, 2)
      }
    },
    model: {
      value: (_vm.firstDetailUrl),
      callback: function($$v) {
        _vm.firstDetailUrl = $$v
      },
      expression: "firstDetailUrl"
    }
  })], 1)]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("挂科科目预约页")]), _vm._v(" "), _c('p', {
    staticClass: "liR"
  }, [_c('van-uploader', {
    attrs: {
      "preview-size": "100px",
      "after-read": function (file) {
        _vm.afterRead(file, 13)
      },
      "before-read": _vm.beforeRead,
      "max-count": 1
    },
    on: {
      "delete": function (file) {
        _vm.deletePhoto(file, 2)
      }
    },
    model: {
      value: (_vm.incidentSubjectUrl),
      callback: function($$v) {
        _vm.incidentSubjectUrl = $$v
      },
      expression: "incidentSubjectUrl"
    }
  })], 1)]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("考试费缴纳页")]), _vm._v(" "), _c('p', {
    staticClass: "liR"
  }, [_c('van-uploader', {
    attrs: {
      "preview-size": "100px",
      "after-read": function (file) {
        _vm.afterRead(file, 14)
      },
      "before-read": _vm.beforeRead,
      "max-count": 1
    },
    on: {
      "delete": function (file) {
        _vm.deletePhoto(file, 2)
      }
    },
    model: {
      value: (_vm.testFeeUrl),
      callback: function($$v) {
        _vm.testFeeUrl = $$v
      },
      expression: "testFeeUrl"
    }
  })], 1)]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("考试费缴纳页(待缴费)")]), _vm._v(" "), _c('p', {
    staticClass: "liR"
  }, [_c('van-uploader', {
    attrs: {
      "preview-size": "100px",
      "after-read": function (file) {
        _vm.afterRead(file, 15)
      },
      "before-read": _vm.beforeRead,
      "max-count": 1
    },
    on: {
      "delete": function (file) {
        _vm.deletePhoto(file, 2)
      }
    },
    model: {
      value: (_vm.waitTestFeeUrl),
      callback: function($$v) {
        _vm.waitTestFeeUrl = $$v
      },
      expression: "waitTestFeeUrl"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_c('van-icon', {
    attrs: {
      "name": "info"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "spL"
  }, [_vm._v("温馨提示: ")]), _vm._v(" "), _c('span', {
    staticClass: "spR"
  }, [_c('code', [_vm._v("1、实际补偿金额以当地车管所为准!")]), _c('br'), _c('code', [_vm._v("2、挂科日期需要在服务有效期内，有效期1年。")]), _c('br')])], 1), _vm._v(" "), _c('div', {
    staticClass: "photo",
    attrs: {
      "data-type": "1"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("证件照上传")]), _vm._v(" "), _c('ul', {
    staticClass: "h5Camera"
  }, [_c('li', {
    staticClass: "front"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("身份证正面")]), _vm._v(" "), _c('van-uploader', {
    attrs: {
      "preview-size": "100px",
      "after-read": function (file) {
        _vm.afterRead(file, 1)
      },
      "before-read": _vm.beforeRead,
      "max-count": 1
    },
    on: {
      "delete": function (file) {
        _vm.deletePhoto(file, 2)
      }
    },
    model: {
      value: (_vm.fileListFront),
      callback: function($$v) {
        _vm.fileListFront = $$v
      },
      expression: "fileListFront"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "behind"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("身份证反面")]), _vm._v(" "), _c('van-uploader', {
    attrs: {
      "preview-size": "100px",
      "after-read": function (file) {
        _vm.afterRead(file, 2)
      },
      "before-read": _vm.beforeRead,
      "max-count": 1
    },
    on: {
      "delete": function (file) {
        _vm.deletePhoto(file, 2)
      }
    },
    model: {
      value: (_vm.fileListBack),
      callback: function($$v) {
        _vm.fileListBack = $$v
      },
      expression: "fileListBack"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "sign"
  }, [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.gotoSign
    }
  }, [_vm._v(" 手写签名")])])])], 1), _vm._v(" "), _c('p', {
    staticClass: "protocol"
  }, [_c('van-checkbox', {
    attrs: {
      "icon-size": "18px"
    },
    on: {
      "change": _vm.readBook
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("我已阅读\n")])], 1), _vm._v(" "), _c('van-dialog', {
    style: ({
      top: _vm.isPhone ? '50%' : ''
    }),
    attrs: {
      "title": "手写签名",
      "show-cancel-button": false,
      "showConfirmButton": false,
      "width": _vm.isPhone ? '100%' : '900px'
    },
    model: {
      value: (_vm.signShow),
      callback: function($$v) {
        _vm.signShow = $$v
      },
      expression: "signShow"
    }
  }, [_c('signer', {
    on: {
      "set-sign": _vm.setSign
    }
  })], 1), _vm._v(" "), (_vm.openBtn) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.submit
    }
  }, [_c('span', [_vm._v("下一步")])]) : _vm._e()], 1), _vm._v(" "), (_vm.datetimeFlag) ? _c('van-datetime-picker', {
    attrs: {
      "type": "date",
      "title": "",
      "formatter": _vm.formatter
    },
    on: {
      "cancel": _vm.cancelDatetime,
      "confirm": _vm.queryTime
    },
    model: {
      value: (_vm.currentDate),
      callback: function($$v) {
        _vm.currentDate = $$v
      },
      expression: "currentDate"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.provinceListShowFlag) ? _c('van-picker', {
    attrs: {
      "title": "",
      "show-toolbar": "",
      "columns": _vm.provinceList
    },
    on: {
      "confirm": _vm.onConfirmCity,
      "cancel": _vm.onCancelCity
    }
  }) : _vm._e(), _vm._v(" "), (_vm.claimClassShowFlag) ? _c('van-picker', {
    attrs: {
      "title": "",
      "show-toolbar": "",
      "columns": _vm.claimClassList
    },
    on: {
      "confirm": _vm.onConfirmClaimClass,
      "cancel": _vm.onCancelClaimClass
    }
  }) : _vm._e(), _vm._v(" "), (_vm.resultShowFlag) ? _c('van-picker', {
    attrs: {
      "title": "",
      "show-toolbar": "",
      "columns": _vm.resultList
    },
    on: {
      "confirm": _vm.onConfirmResult,
      "cancel": _vm.onCancelResult
    }
  }) : _vm._e(), _vm._v(" "), _c('popup', {
    ref: "popupShows"
  }), _vm._v(" "), _c('ajaxLoading', {
    ref: "loading"
  }), _vm._v(" "), _c('maskPopup', {
    ref: "maskShow"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.protocolDetailFlag),
      expression: "protocolDetailFlag"
    }],
    staticClass: "protocolDetail"
  }, [_c('h3', [_vm._v("云南祐祉商务信息咨询有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "protocolDetailBox"
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("\n          【特别提醒】在您（以下亦称“本人”）确认本《个人信息使用授权书》（以下简称“本授权书”）之前，请您务必充分阅读本授权书所有内容。由于本授权书内容对您至关重要，如您对本授权书内容有任何疑问，请立即暂停后续操作。一旦您通过本网络服务页面进行确认，即视为您同意以数据电文形式签署本授权书。")]), _vm._v(" "), _c('p', [_vm._v("致：云南祐祉商务信息咨询有限公司（以下称“贵公司”）")]), _vm._v(" "), _c('p', [_vm._v("\n          本人为贵公司代理推广的保险产品中被保险人，现本人拟通过贵公司向（具体以实际承保的为准）提交补偿申请。贵公司和在补偿过程中需收集、了解、使用本人的个人信息资料，用于每次（每笔）补偿中的审核（以下简称“审核”），故本人自愿同意并不可撤销，特做出以下操作授权：")]), _vm._v(" "), _c('p', [_vm._v("1、贵公司有权在收到本人补偿申请后进行下列操作，即采集、查询、验证、整理、保存本人提交的全部信息（简称“申请补偿信息”），并将本人每次申请补偿的信息提供给，由对本人进行审核。")]), _vm._v(" "), _c('p', [_vm._v("2、贵公司有权从处获得本人的补偿审核结果及相关信息，并有权保存全部相关信息供本人进行查询。")]), _vm._v(" "), _c('p', [_vm._v("\n          3、本人确认本授权书所称本人“个人信息”，包括但不限于如下内容：本人姓名、证件类型、证件号码、证件影印件、联系方式、性别、住址、电子邮箱、财务信息、征信信息、个人健康信息、车辆信息等，具体以本人实际提供的个人信息和反馈的信息为准。")]), _vm._v(" "), _c('p', [_vm._v("4、贵公司及收到本人申请补偿信息的，均有权按如下用途及方式使用本人个人信息：")]), _vm._v(" "), _c('p', [_vm._v("（1）审核本人提交的每个补偿申请；")]), _vm._v(" "), _c('p', [_vm._v("（2）进行客户身份信息识别；")]), _vm._v(" "), _c('p', [_vm._v("（3）履行反洗钱义务；")]), _vm._v(" "), _c('p', [_vm._v("（4）监管机构规定需要使用本人个人信息的情况。")]), _vm._v(" "), _c('p', [_vm._v("5、本人因投保和补偿需要，授权贵公司在本人投保保单成功生效后，通过公安部交通安全综合服务管理平台（www.122.gov.cn）查询本人相关的交管、驾考信息等内容。")]), _vm._v(" "), _c('p', [_vm._v("6、本授权书有效期限约定为自本人做出本授权承诺之日起至补偿完成，或补偿申请被拒绝之日止。")]), _vm._v(" "), _c('p', [_vm._v("本人已知悉本授权书上述全部内容的含义及因此产生的法律效力【包括但不限于：上述信息对本人是否可以成功补偿、以及补偿金额等结果产生不利影响的风险】。 本授权书完全是本人真实意思表示，本人同意承担由此产生的一切法律后果。\n          本授权书效力具有独立性，不因相关保险合同或条款无效或被撤销而无效或失效，本授权书一经签署，便不可撤销。")]), _vm._v(" "), _c('div', {
    staticClass: "sign"
  }, [_c('p', [_vm._v("授权人签字：" + _vm._s(_vm.userName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(new Date().getFullYear()) + "年" + _vm._s(new Date().getMonth() + 1) + "月" + _vm._s(new Date().getDate()) + "日")])])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/closeImg.png"),
      "alt": ""
    },
    on: {
      "click": _vm.closeProtocol
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3646e68f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/applyClaim.vue
// module id = 475
// module chunks = 1